import React from 'react';
import { useStyles } from '../../hooks/useStyles';
import theme from '../../../lib/themes/linkpick/new_theme';

const Checkbox = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  name,
  className = "",
  ...props
}) => {
  const { classes, cx } = useStyles(style);

  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e);
    }
  };

  const checkmarkClass = cx(
    classes.checkmark,
    checked && classes.checkmarkChecked,
    disabled && classes.disabled
  );

  const iconClass = cx(
    classes.icon,
    checked && classes.iconChecked
  );

  const labelClass = cx(
    classes.label,
    disabled && classes.labelDisabled
  );

  return (
    <label className={cx(classes.container, theme.components.checkbox)} {...props}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        name={name}
        className={classes.input}
      />
      <span className={checkmarkClass}>
        {/* <span className={iconClass}>✓</span> */}
      </span>
      {label && <span className={labelClass}>{label}</span>}
    </label>
  );
};

const style = () => ({
  checkbox: theme.components.checkbox
})

export default Checkbox; 